<template>
  <div>
    <vs-col type="flex" vs-w="4" vs-lg="2" vs-md="2" vs-xs="12" style="margin-bottom: 20px;" :key="indexData" v-for="(data, indexData) in queues">
      <vs-card class="cardx">
        <div slot="header">
          <vs-row>
            <vs-col vs-w="12" class="text-center queue-editable">
              <vs-button radius color="success" class="queue-edit-button" type="border" icon="edit" size="small" @click.prevent="editLabel(data)"></vs-button>
              <h2>
                <span v-if="data.label && data.label.length > 0" v-text="data.label"/>
                <span v-else v-text="data.number" />
              </h2>
              <vs-divider/>
              <vs-button color="success" type="filled" @click.prevent="viewInfo(data.number)" v-text="$t('view_info')"></vs-button>
            </vs-col>
          </vs-row>
        </div>
      </vs-card>
    </vs-col>
  </div>
</template>

<script>

import ctiWindow from '@/helpers/ctiWindow'

export default {
  name: 'Shared.Queues.List',
  props: {
    queues: {
      type: [Object, Array],
      required: true
    }
  },
  methods: {
    viewInfo (queue) {
      if(queue == "5000") {
        ctiWindow.queueStatusCdrWindow(queue)
      } else {
        ctiWindow.queueStatusWindow(queue)
      }
    },
    editLabel (data) {
      ctiWindow.editQueueStatusLabelWindow(data)
    }
  }
}
</script>

<style scoped>
.cardx {
    width: calc(100% - 25px);
    margin: 5px;
}
.queue-edit-button {
  position: absolute;
  right: -15px;
  top: -15px;
  background-color: #fff !important;
}
.queue-editable {
  position: relative;
}
</style>
